import { WhatIsTrackedKeywordIcon } from '@modules/taxonomy/components/AddNewTrackedKeywordContainer/WhatIsTrackedKeywordIcon';
import { Stack, Paper, Typography, Box } from '@mui/material';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';

export const AddNewTrackedKeywordIllustration = () => {
  const whatIsTrackedKeywordSection = (
    <Stack>
      <Typography variant="subtitle2">What is a Tracked Keyword?</Typography>
      <Stack direction="row" spacing={1}>
        <FiberManualRecordRoundedIcon
          color="disabled"
          sx={{
            width: '12px',
            height: '12px',
            mt: 0.5,
          }}
        />
        <Typography variant="caption">
          Tracked keywords are how your customers would describe different
          aspects of your product.
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
        <FiberManualRecordRoundedIcon
          color="disabled"
          sx={{
            width: '12px',
            height: '12px',
            mt: 0.5,
          }}
        />
        <Box
          component="p"
          sx={{
            lineHeight: 1,
          }}
        >
          <Typography component="span" variant="caption">
            For Example :{' '}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            “Chrome” is a Tracked Keyword composed of the phrases “chromium” and
            “chrome”. When users mention “chrome” or “chromium”, Enterpret will
            tag the feedback with the Tracked Keyword “Chrome”.
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );

  const guidelinesForNewKeywordsSection = (
    <>
      <Typography variant="subtitle2">Guidelines for new keywords</Typography>
      <Stack direction="row" spacing={1}>
        <FiberManualRecordRoundedIcon
          color="disabled"
          sx={{
            width: '12px',
            height: '12px',
            mt: 0.5,
          }}
        />
        <Box
          component="p"
          sx={{
            lineHeight: 1,
          }}
        >
          <Typography variant="caption">
            Name of the keyword must be indicative of the phrases{' '}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            (eg: Keyword-Mac and Phrase-Macintosh, MacOS, MacOSX)
          </Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1}>
        <FiberManualRecordRoundedIcon
          color="disabled"
          sx={{
            width: '12px',
            height: '12px',
            mt: 0.5,
          }}
        />
        <Box
          component="p"
          sx={{
            lineHeight: 1,
          }}
        >
          <Typography variant="caption">
            While adding phrases, you don’t need to add plurals or syntactical
            variations{' '}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            (like hyphenation)
          </Typography>
        </Box>
      </Stack>
    </>
  );

  return (
    <Stack spacing={2.5}>
      <Stack
        component={Paper}
        p={2}
        borderRadius={3}
        alignItems="center"
        boxShadow="none"
      >
        <WhatIsTrackedKeywordIcon />
      </Stack>
      <Stack component={Paper} p={2} borderRadius={3} boxShadow="none">
        {whatIsTrackedKeywordSection}
      </Stack>
      <Stack component={Paper} p={2} borderRadius={3} boxShadow="none">
        {guidelinesForNewKeywordsSection}
      </Stack>
    </Stack>
  );
};
